import React from "react";
import Select from "react-select";

import ErrorMessage from "@components/form/ErrorMessage";
import { useGetBillingGroups } from "@hooks/query/useGetBillingGroups";

type SelectProps = React.ComponentProps<Select>;

type SelectBillingGroupProps = Exclude<SelectProps, "value"> & {
  level1ResourceId: string;
  value?: string;
  errorMessage?: string;
  isClearable?: boolean;
  chargeType?: "any" | "dynamic";
  waterClassId?: string;
};

const SelectBillingGroup: React.FunctionComponent<SelectBillingGroupProps> = ({
  level1ResourceId,
  value,
  errorMessage,
  chargeType = "any",
  waterClassId,
  ...restProps
}) => {
  const hasDynamicCharge = (billingGroup: any) => {
    return (billingGroup.waterCharges ?? []).some((charge: any) =>
      waterClassId
        ? (charge.waterClasses ?? []).some(
            (waterClass: any) => waterClass.id === waterClassId,
          )
        : (charge.waterClasses?.length ?? 0) > 0,
    );
  };

  const { data: options = [], isLoading } = useGetBillingGroups({
    params: { level1ResourceId },
    options: {
      select: (data: any) => {
        return data
          .filter((bg: any) =>
            chargeType === "dynamic" ? hasDynamicCharge(bg) : true,
          )
          .map((bg: any) => ({
            label: bg.name,
            value: bg.id,
          }))
          .sort((a: any, b: any) => a.label.localeCompare(b.label));
      },
    },
  });

  if (isLoading) {
    return null;
  }

  return (
    <div className="flex flex-col w-full">
      <Select
        options={options}
        value={options.find((i: any) => i.value === value)}
        styles={{
          menuPortal: base => ({
            ...base,
            zIndex: 9999,
          }),
        }}
        menuPortalTarget={document.body}
        openMenuOnFocus
        {...restProps}
      />
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </div>
  );
};

export default SelectBillingGroup;
